const license = {
    not_installed: '此实例尚未安装许可证。',
    invalid_key: '许可证密钥无效或已被篡改。',
    expired_key: '许可证密钥已过期。请获取新的密钥并重新安装。',
};
export default Object.freeze(license);
